// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"4d4f5779","181":"5bdf7b0b","359":"20e4f6f5","432":"505812ed","478":"653b65e2","566":"c578063f","664":"df8e7c7f","706":"7946dd39","869":"2d97603f","895":"39625112","908":"7b9a254e"}[chunkId] + ".chunk.js";
};